(function () {
  function money(cents, sample) {
    var sym = (sample || '').replace(/[0-9.,\s]/g, '') || '';
    var amount = (cents / 100);
    var str = amount % 1 === 0 ? String(amount) : amount.toFixed(2);
    return sym + str;
  }

  function init(root) {
    if (!root || root.__nettoInit) return;
    root.__nettoInit = true;

    var dataEl = root.querySelector('[data-netto-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var sample = variants[0].price_formatted;
    var idInput = root.querySelector('[data-variant-id]');
    var atcBtn = root.querySelector('[data-atc]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var mainPrice = root.querySelector('[data-main-price]');
    var soldNote = root.querySelector('[data-soldout-note]');
    var deliveryNote = root.querySelector('[data-delivery]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-opt-group]'));

    /* The media is one run of images per colour, each variant's featured image
       being the first of its run. The sorted set of those start positions gives
       every group boundary. */
    var groupStarts = variants
      .map(function (v) { return v.media_position; })
      .filter(function (p) { return p !== null && p !== undefined; })
      .filter(function (p, i, a) { return a.indexOf(p) === i; })
      .sort(function (a, b) { return a - b; });

    function groupEndFor(start) {
      var slides = root.querySelectorAll('[data-slide]');
      for (var i = 0; i < groupStarts.length; i++) {
        if (groupStarts[i] > start) return groupStarts[i];
      }
      return slides.length;
    }

    /* The sold out notice takes the delivery estimate's place, since a date is
       meaningless when there is nothing to ship. */
    function setSoldOut(out) {
      if (soldNote) soldNote.hidden = !out;
      if (deliveryNote) deliveryNote.hidden = out;
    }

    function selectedValues() {
      return groups.map(function (g) {
        var checked = g.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(values) {
      return variants.filter(function (v) {
        return values.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    }

    /* Badge positions are RELATIVE to the selected variant's image group:
       data-badge-on="1" is the first image of whichever colour is selected;
       0 pins a badge to every image. */
    function syncBadges(index) {
      var start = root.__groupStart || 0;
      var badges = root.querySelectorAll('[data-badge-on]');
      Array.prototype.forEach.call(badges, function (el) {
        var on = parseInt(el.getAttribute('data-badge-on'), 10);
        if (isNaN(on)) on = 0;
        el.hidden = !(on === 0 || index === start + on - 1);
      });
    }

    /* Only the selected colour's images are shown: slides and thumbnails
       outside the group get the hidden attribute, which netto-product.css
       turns into display:none. This also keeps the phone thumbnail strip to
       one colour's worth of thumbs. Skipped entirely when the product has no
       per variant media. */
    function filterMedia() {
      if (!groupStarts.length) return;
      var start = root.__groupStart || 0;
      var end = root.__groupEnd || groupEndFor(start);
      var slides = root.querySelectorAll('[data-slide]');
      var thumbs = root.querySelectorAll('[data-thumb]');
      Array.prototype.forEach.call(slides, function (s, i) { s.hidden = i < start || i >= end; });
      Array.prototype.forEach.call(thumbs, function (t, i) { t.hidden = i < start || i >= end; });
    }

    /* The gallery wraps WITHIN the selected colour's group: next past the last
       image of the group returns to the group's first, and previous from the
       group's first goes to its last. */
    function setSlide(index) {
      var slides = root.querySelectorAll('[data-slide]');
      var thumbs = root.querySelectorAll('[data-thumb]');
      if (!slides.length) return;
      var start = groupStarts.length ? (root.__groupStart || 0) : 0;
      var end = groupStarts.length ? (root.__groupEnd || groupEndFor(start)) : slides.length;
      if (index < start) index = end - 1;
      if (index >= end) index = start;
      Array.prototype.forEach.call(slides, function (s, i) { s.classList.toggle('is-active', i === index); });
      Array.prototype.forEach.call(thumbs, function (t, i) { t.classList.toggle('is-active', i === index); });
      root.__slide = index;
      syncBadges(index);
    }

    function refreshLensDeltas() {
      var values = selectedValues();
      var lensGroup = root.querySelector('[data-opt-group][data-opt-role="lens"]');
      if (!lensGroup) return;
      var lensIndex = parseInt(lensGroup.getAttribute('data-opt-index'), 10);
      var candidates = [];
      Array.prototype.forEach.call(lensGroup.querySelectorAll('input'), function (input) {
        var probe = values.slice();
        probe[lensIndex] = input.value;
        var v = findVariant(probe);
        if (v) candidates.push({ input: input, price: v.price });
      });
      if (!candidates.length) return;
      var base = Math.min.apply(null, candidates.map(function (c) { return c.price; }));
      candidates.forEach(function (c) {
        var host = c.input.closest('[data-lensopt]');
        if (!host) return;
        var slot = host.querySelector('[data-lens-delta]');
        if (!slot) return;
        var delta = c.price - base;
        if (delta <= 0) {
          slot.className = 'npdp-pill';
          slot.textContent = slot.getAttribute('data-free-label') || 'Free';
        } else {
          slot.className = 'npdp-delta';
          slot.textContent = '+ ' + money(delta, sample);
        }
      });
    }

    /* The bar mirrors state, it never owns it. Everything here is read from the
       variant update() has just resolved, so the two can never disagree. */
    function syncSticky(variant) {
      var bar = root.querySelector('[data-sticky-bar]');
      if (!bar) return;

      var chosen = null;
      groups.forEach(function (g) {
        if (g.getAttribute('data-opt-role') !== 'color') return;
        var checked = g.querySelector('input:checked');
        if (checked) chosen = checked.value;
      });
      Array.prototype.forEach.call(bar.querySelectorAll('[data-sticky-swatch]'), function (b) {
        var on = b.getAttribute('data-value') === chosen;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var price = bar.querySelector('[data-sticky-price]');
      var label = bar.querySelector('[data-sticky-label]');
      var cta = bar.querySelector('[data-sticky-cta]');
      var ok = !!(variant && variant.available);
      if (price) price.textContent = ok ? variant.price_formatted : '';
      if (label && atcLabel) {
        label.textContent = ok
          ? (atcLabel.getAttribute('data-default') || 'Add to Cart')
          : (atcLabel.getAttribute('data-soldout') || 'Sold Out');
      }
      if (cta) cta.disabled = !ok;
    }

    function update() {
      var values = selectedValues();
      var variant = findVariant(values);

      groups.forEach(function (g) {
        Array.prototype.forEach.call(g.querySelectorAll('input'), function (input) {
          var host = input.closest('[data-swatch]') || input.closest('[data-lensopt]');
          if (host) host.classList.toggle('is-selected', input.checked);
        });
        var out = g.parentElement.querySelector('[data-opt-selected]');
        var checked = g.querySelector('input:checked');
        if (out && checked) out.textContent = checked.value;
      });

      refreshLensDeltas();

      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; }
        if (atcLabel) atcLabel.textContent = atcLabel.getAttribute('data-soldout') || 'Sold Out';
        setSoldOut(true);
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (mainPrice) mainPrice.textContent = variant.price_formatted;
      if (atcPrice) atcPrice.textContent = variant.price_formatted;
      if (atcBtn) atcBtn.disabled = !variant.available;
      if (atcLabel) {
        atcLabel.textContent = variant.available
          ? (atcLabel.getAttribute('data-default') || 'Add to Cart')
          : (atcLabel.getAttribute('data-soldout') || 'Sold Out');
      }
      setSoldOut(!variant.available);

      if (variant.media_position !== null && variant.media_position !== undefined) {
        root.__groupStart = variant.media_position;
        root.__groupEnd = groupEndFor(variant.media_position);
        filterMedia();
        setSlide(variant.media_position);
      }

      syncSticky(variant);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-opt-group] input')) update();
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-thumb]'), function (t, i) {
      t.addEventListener('click', function () { setSlide(i); });
    });
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { setSlide((root.__slide || 0) - 1); });
    if (next) next.addEventListener('click', function () { setSlide((root.__slide || 0) + 1); });

    var deliveryEl = root.querySelector('[data-delivery]');
    if (deliveryEl) {
      var cutoffHour = parseInt(deliveryEl.getAttribute('data-cutoff') || '17', 10);
      var dayEl = deliveryEl.querySelector('[data-delivery-day]');
      var cdEl = deliveryEl.querySelector('[data-delivery-countdown]');
      var tick = function () {
        var now = new Date();
        var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0);
        if (now >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
        var ship = new Date(cutoff.getTime());
        var added = 0;
        while (added < 2) {
          ship.setDate(ship.getDate() + 1);
          var d = ship.getDay();
          if (d !== 0 && d !== 6) added++;
        }
        /* A date rather than a weekday: "Aug 02" is unambiguous a week out,
           where "Tuesday" is not. */
        if (dayEl) dayEl.textContent = ship.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
        var diff = Math.max(0, cutoff - now);
        var hrs = Math.floor(diff / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        if (cdEl) cdEl.textContent = hrs + ' hours and ' + mins + ' minutes';
      };
      tick();
      setInterval(tick, 30000);
    }

    /* Once the main button has scrolled out of sight the bar stays, footer
       included. It used to retract as the footer came up, which took the only
       buy control off screen exactly where a shopper who had read to the end
       might use it. The footer already reserves 86px for the bar in
       netto-footer.css, so nothing is covered by leaving it out. */
    var bar = root.querySelector('[data-sticky-bar]');
    if (bar && atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          bar.setAttribute('data-stuck', past ? 'true' : 'false');
        });
      }, { threshold: 0 }).observe(atcBtn);

    }

    /* Wired outside the IntersectionObserver block: the bar still has to work if
       the observers never run, and these two do not depend on them. */
    var stickyBar = root.querySelector('[data-sticky-bar]');
    if (stickyBar) {
      /* A bar swatch ticks the real radio and hands over. Dispatching change
         rather than calling update() directly keeps the one code path, so the
         gallery, price, variant id and sold out state all follow as they do for
         the swatches on the page. */
      Array.prototype.forEach.call(stickyBar.querySelectorAll('[data-sticky-swatch]'), function (b) {
        b.addEventListener('click', function () {
          var value = b.getAttribute('data-value');
          var target = null;
          groups.forEach(function (g) {
            if (g.getAttribute('data-opt-role') !== 'color') return;
            Array.prototype.forEach.call(g.querySelectorAll('input'), function (input) {
              if (input.value === value) target = input;
            });
          });
          if (!target || target.checked) return;
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      /* requestSubmit, not submit: only the former fires the submit event, and
         that event is what the AJAX handler below intercepts. Calling submit()
         would post the page and land the shopper on /cart. */
      var stickyCta = stickyBar.querySelector('[data-sticky-cta]');
      if (stickyCta && atcBtn && atcBtn.form) {
        stickyCta.addEventListener('click', function () {
          if (stickyCta.disabled || atcBtn.disabled) return;
          if (atcBtn.form.requestSubmit) atcBtn.form.requestSubmit(atcBtn);
          else atcBtn.click();
        });
      }
    }

    /* update() seeds the group bounds, filters the media and jumps to the
       selected variant's first image, which also covers ?variant= deep links. */
    update();
    if (root.__slide === undefined) {
      filterMedia();
      setSlide(root.__groupStart || 0);
    }
  }

  /* ---- AJAX add to cart ----
     The custom sections use plain Liquid product forms, which Horizon's own cart
     JS does not intercept. A normal submit therefore posts the page and Shopify
     redirects to /cart instead of opening the drawer. */

  function drawerHost() {
    return document.getElementById('shopify-section-cart-drawer-section');
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      if (typeof drawer.show === 'function') { try { drawer.show(); return true; } catch (e) {} }
      if (typeof drawer.open === 'function') { try { drawer.open(); return true; } catch (e) {} }
    }
    var icon = document.querySelector('cart-icon');
    var trigger = icon && icon.closest('button, a');
    if (trigger) { trigger.click(); return true; }
    return false;
  }

  function refreshCartDrawer() {
    var host = drawerHost();
    if (!host) return Promise.resolve();
    var url = window.location.pathname + '?section_id=cart-drawer-section';
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('shopify-section-cart-drawer-section');
        host.innerHTML = next ? next.innerHTML : html;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!drawerHost()) return;

    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = form.querySelector('[data-atc-label]');
    var previous = label ? label.textContent : null;
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Adding';

    var restore = function () {
      if (btn) btn.disabled = false;
      if (label && previous !== null) label.textContent = previous;
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () { return refreshCartDrawer(); })
      .then(function () { restore(); openCartDrawer(); })
      .catch(function () { restore(); form.submit(); });
  });

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-netto-pdp]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
